export function remove(array, element) {
    return array.filter(el => el !== element);
}